import { marketingRouteMeta } from '#marketing/lib/marketing-route-meta.js';
import { MarketingHowItWorksPage } from '#marketing/components/MarketingHowItWorksPage.jsx';

/** @param {{ matches: Array<{ id?: string, pathname?: string, data?: unknown }> }} args */
export function meta({ matches }) {
  return marketingRouteMeta({ matches, page: 'howItWorks', pagePath: '/how-it-works' });
}

export default function HowItWorks() {
  return <MarketingHowItWorksPage />;
}
